export default {
  title: 'Cronologia modifiche menu',
  subtitle: 'Visualizza chi ha modificato prezzi, disponibilità e visibilità per {{company}} — e quando.',
  filters: {
    type: {
      label: 'Tipo',
    },
    item: {
      placeholder: 'Tutti gli elementi',
    },
    event: {
      label: 'Evento',
    },
  },
  columns: {
    when: 'Quando',
    who: 'Modificato da',
    type: 'Tipo',
    item: 'Elemento',
    event: 'Evento',
    changes: 'Modifiche',
  },
  types: {
    product: 'Prodotto',
    modifier: 'Modificatore',
  },
  events: {
    created: 'Creato',
    updated: 'Aggiornato',
    deleted: 'Eliminato',
  },
  fields: {
    name: 'Nome',
    description: 'Descrizione',
    price: 'Prezzo',
    is_available: 'Disponibilità',
    is_visible: 'Visibilità',
    is_available_for_pickup: 'Disponibilità asporto',
    is_available_for_delivery: 'Disponibilità consegna',
  },
  booleans: {
    on: 'Disponibile',
    off: 'Non disponibile',
  },
  pagination: {
    previous: 'Precedente',
    next: 'Successivo',
  },
  causers: {
    orders_terminal: 'Terminale ordini',
  },
  system: 'Sistema',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Caricamento cronologia modifiche menu fallito',
  },
};
